"use client";

import { useCleverTapPageView } from "@/app/hooks/use-clevertap";

/**
 * Component to automatically track page views in CleverTap
 * This component should be placed in the root layout
 */
const CleverTapPageViewTracker = () => {
    useCleverTapPageView();
    return null;
};

export default CleverTapPageViewTracker;
